import(/* webpackMode: "eager" */ "/opt/fructidor/fructidor-ui/releases/20250423170259/app/[lng]/error.tsx");
